/**
 * Портал «Тоскана» — один сайт вместо трёх сборок (ТЗ портала, D185).
 *
 * Этап P1: каркас, вход, «Сегодня» и «Накладные» (до 21.10.2026 —
 * «Приёмка»). Разделы следующих этапов в меню видны тем, у кого есть
 * право, и открывают экран «скоро» со ссылкой на нынешнее место.
 */

import { useEffect } from 'react';
import { Denied } from '@shell/states';
import { PortalShell } from './PortalShell';
import { canSee, sectionForPath } from './nav';
import { navigate, useRoute } from './router';
import { Receipts } from './screens/Receipts';
import { fromReconcilePath } from './sections/payments/paths';
import { SECTION_SCREENS } from './sections/registry';
import { Today } from './screens/Today';

/** Прежний адрес «Сверки» — куда он ведёт теперь, или `null`. */
function movedFrom(path: string, params: URLSearchParams): string | null {
  if (path !== '/reconcile' && !path.startsWith('/reconcile/')) return null;
  const search = params.toString();
  return `${fromReconcilePath(path)}${search ? `?${search}` : ''}`;
}

export function App() {
  const route = useRoute();
  // «Сверка» — вкладки «Оплат» (D267): старая ссылка ведёт туда же. Эффект
  // здесь, а не в дочернем экране: дочерний сработал бы раньше, чем
  // `useRoute` начал слушать смену адреса, и страница осталась бы пустой.
  const moved = movedFrom(route.path, route.params);
  useEffect(() => {
    if (moved) navigate(moved, { replace: true });
  }, [moved]);
  if (moved) return null;
  return (
    <PortalShell>
      {(nav) => {
        const section = sectionForPath(route.path);
        if (!section) {
          return <Today nav={nav} />;
        }
        if (!canSee(section.code, nav)) return <Denied />;
        if (section.code === 'today') return <Today nav={nav} />;
        if (section.code === 'receipts') return <Receipts nav={nav} />;
        const Screen = SECTION_SCREENS[section.code as keyof typeof SECTION_SCREENS];
        return Screen ? <Screen nav={nav} /> : <Today nav={nav} />;
      }}
    </PortalShell>
  );
}
